import css from "styled-jsx/css";
import { colors, grid } from "../constants";

export default css`
:global(.card-cont) {
  padding: 0 !important;
  border: none !important;
}
:global(.card-cont) .shadow {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.5) 33%, rgba(0, 0, 0, 0) 44%, rgba(0, 0, 0, 0) 100%);
}

.streaming-card-link {
  height: 100%;
}

.streaming-card {
  width: 15.25rem;
  height: 100%;
  border-radius: 1rem;
  display: flex;
  align-items: flex-end;
  background-color: #262423;
  padding-top: 0px;
  overflow: hidden;
}
.streaming-card .card-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex-grow: 1;
  position: relative;
  height: 100%;
  overflow: hidden;
}
.streaming-card .card-content-image {
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;
}
.streaming-card .card-content-image :global(.image) {
  border-radius: 1rem;
}
.streaming-card .card-content-text {
  width: 100%;
  height: 100%;
  align-items: flex-end;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0rem 1rem 1rem 1rem;
}
.streaming-card .card-content :global(.title) {
  margin-bottom: 1rem;
}
.streaming-card .card-content .separator {
  height: 1px;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  background-color: ${colors.color_gp__grey4};
  display: block;
  width: 100%;
}
.streaming-card .card-content :global(.price-container) .container-text-price {
  display: inline-flex;
}
.streaming-card .card-content :global(.button-añadir) {
  display: none;
}

@media screen and (min-width: ${grid.breakpoint_sm}px) {
  .streaming-card {
    width: min(29vw, 480px);
    /* height: 20rem; */
  }
  .streaming-card .card-content :global(.button-añadir) {
    display: inline-block;
    line-height: 1.8rem;
  }
  .streaming-card .card-content :global(.price-container) .container-text-price {
    display: flex;
    align-items: center;
  }
}
@media screen and (min-width: ${grid.breakpoint_md}px) {
  .streaming-card {
    /* height: 28rem; */
  }
  .streaming-card .card-content-text {
    padding: 0rem 1.5rem 1.5rem 1.5rem;
  }
  .streaming-card .card-content .separator {
    margin-bottom: 1rem;
  }
  .streaming-card .card-content :global(.price-container) .container-text-price {
    display: inline-flex;
  }
  .streaming-card .card-content :global(.button-añadir) {
    display: none;
  }
}
@media screen and (min-width: 1400px) {
  .streaming-card {
    width: min(28vw, 480px);
  }
}
`;
